import { Italic } from 'almanac-ui/icons/16'
import { useItalicToggle } from 'common/Prose/Toolbar/hooks/useItalicToggle'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const ItalicInlineFormatButton = observer(function ItalicInlineFormatButton({ view }: { view: EditorView }) {
  const { active, disabled, handleClick } = useItalicToggle(view)

  return (
    <InlineFormatButton
      label="Italic"
      shortcutKeys="i"
      shortcutModifiers={['Mod']}
      data-testid="Set italic"
      aria-label="Set italic"
      active={active}
      onPress={handleClick}
      isDisabled={disabled}
    >
      <Italic />
    </InlineFormatButton>
  )
})
